var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcnYt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3427 8.505C32.1561 7.80294 31.7885 7.1622 31.2764 6.6469C30.7644 6.1316 30.1261 5.75981 29.4252 5.56875C26.8452 4.875 16.5327 4.875 16.5327 4.875C16.5327 4.875 6.22022 4.875 3.64021 5.56875C2.93937 5.75981 2.301 6.1316 1.78899 6.6469C1.27697 7.1622 0.909285 7.80294 0.722715 8.505C0.0327149 11.0963 0.0327148 16.5 0.0327148 16.5C0.0327148 16.5 0.0327149 21.9038 0.722715 24.495C0.909285 25.1971 1.27697 25.8378 1.78899 26.3531C2.301 26.8684 2.93937 27.2402 3.64021 27.4313C6.22022 28.125 16.5327 28.125 16.5327 28.125C16.5327 28.125 26.8452 28.125 29.4252 27.4313C30.1261 27.2402 30.7644 26.8684 31.2764 26.3531C31.7885 25.8378 32.1561 25.1971 32.3427 24.495C33.0327 21.9038 33.0327 16.5 33.0327 16.5C33.0327 16.5 33.0327 11.0963 32.3427 8.505Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1578 21.4065V11.5928L21.7828 16.4996L13.1578 21.4065Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcnYt);
export default __webpack_public_path__ + "static/media/social-icn-yt.96bf623d7e2e0e62a88d5f101ece98d0.svg";
export { ForwardRef as ReactComponent };